<template>
	<div>
	  <SubTopNav :title="title" :image="image" />
	  <div v-if="currentContent">
			<transition  mode="out-in" appear enter-active-class="animated zoomIn" leave-active-class="animated zoomOut">
				<div class="current-person">
					<div class="close-icon" @click="closeItem()"><i class="fas fa-times fa-2x"></i></div>
					<h3>{{ currentContent.title[0].value }}</h3>
					<div class="profile-pic" v-if="currentContent.field_page_header_image && currentContent.field_page_header_image.length > 0">
						<img :src="currentContent.field_page_header_image[0].url">
					</div>
					<div v-html="currentContent.body[0].value"></div>
					<div v-if="currentContent && currentContent.field_download && currentContent.field_download[0].url"><a :href="currentContent.field_download[0].url" target="_blank" class="btn btn-primary" style="text-decoration:none">Read More &raquo;</a> </div>
				</div>
			</transition>
		</div>
	  <div class="page content">
		<div v-html="content"></div>
		<div></div>
		
		<div :class="['person-grid', 'animated', 'fadeIn']">
			
			<div v-for="(item, index) in pageItems.slice().reverse()" :key="index" class="person animated fadeInUp" @click="loadContent(item)"  v-show="!currentContent || (currentContent && item.nid[0].value != currentContent.nid[0].value)" xv-show="((item.type[0].target_id == showItems) || showItems == 'all')" :style="((
							item.field_page_header_image && 
							item.field_page_header_image.length > 0 && 
							item.field_page_header_image[0].url) ? 'background: url(' + item.field_page_header_image[0].url + ');background-size:cover;' : '')">
				<div class="pcontent">
					{{ item.title[0].value }} &raquo;
					<div class="caption">
						<div v-html="item.body[0].value"></div>

						<!-- <truncate :length="90" type="html" :text="item.body[0].value"></truncate> -->
					</div>
					<div class="read-more">Read more &raquo;</div>
				</div>

			</div>
			<div v-if="pageItems.length == 0">
				<p>&nbsp;</p>
				<i>There are currently no insights. Please check back later.</i>
			</div>

		</div> 		
	  </div>
	
	
  </div>
</template>
<script>
// @ is an alias to /src
	import SubTopNav from "@/components/SubTopNav.vue";
	import { RepositoryFactory } from "@/repositories/RepositoryFactory"
  	const ContentRepository = RepositoryFactory.get("content");

	export default {
	  name: "keyindustries",
	  components: {
	    SubTopNav,
	    // truncate: () => import('vue-truncate-collapsed')
	  },
	  data: function(){
	  	return {
	  		content: null,
	  		image: null,
	  		currentContent:null,
	  		pageItems: [],
	  		showItems:'all',
	  		title:null
	  	}
	  },
	  methods: {
	  	async getPageOverview(){
	  		var type = "page"
	        var id = "31"
	        const { data } = await ContentRepository.get(type, id)

	        if (data.length > 0){
	        	if (data[0].body.length > 0){
	        		this.content = data[0].body[0].value
        		}

        		this.title = data[0].title[0].value
          
	          if (data[0].field_page_header_image.length > 0){
	          	this.image = data[0].field_page_header_image[0].url
	          }
          
        	}
	  	},	
	  	async getContent(){
	  		var type = "insight"
	        var id = "all"
	        const { data } = await ContentRepository.get(type, id)
        

	        if (data.length > 0){
	          this.pageItems = data.reverse()

	          var alias = this.$route.hash

	          if (alias){
	          	alias = alias.replace('#', '/')
	          	var itemArray = this.pageItems.filter(item => {
	          	 	return (alias == item.path[0].alias)
	          	})

	          	if (itemArray.length > 0){
	          		var loadItem = itemArray[0]
	          		this.loadContent(loadItem)
	          	}
	          }
	          
	          
	        }
  		},
  		loadContent(item){
  			var alias = item.path[0].alias.replace('/', '#')
  			history.pushState(
			    {},
			    null,
			    this.$route.path + alias
			)
  			this.currentContent = item
  			window.scrollTo(0,0);

  		},
  		closeItem(){
  			this.currentContent = null

  			var path = this.$route.path
  			history.pushState(
			    {},
			    null,
			    path
			)
  		},
	  },
	  mounted(){
	  	this.getPageOverview()
	  	this.getContent()
	  	
	  }
	};
</script>
<style scoped>
	.page{
		text-align:left;
		margin-left:5%;
	}

	.filter-capabilities{
		text-align:center;
		margin-bottom:20px;
		position:relative;
		z-index:0;
	}

	.profile-pic{
		float:left;
		margin-right:25px;
		margin-bottom:25px;
		margin-top:12px;
		width:400px;


	}


	.profile-pic img{
		max-width:100%;
		border-radius:8px;
	}

	.left-column{
		margin-bottom:25px;
	}

	.person{
		font-size:150%;
		color:#FFF;
		cursor:pointer;
	}

	.person .pcontent{
		padding:80px 30px 30px 30px;
		height:100%;
		text-transform:uppercase;
		font-weight:bold;
		background:rgba(0, 0 ,0 ,0.8);
	}

	.person .pcontent:hover{
		background:rgba(51,153,0,0.9);
	}

	.person .pcontent .caption, .person .pcontent .read-more{
		text-transform: none;
		font-size:80%;
		font-weight:normal;
		height:85px;
		overflow: hidden;
	}

	.person .pcontent .read-more{
		height:auto;
		font-weight:bold;
	}


	.xperson-grid .person:nth-child(n) .pcontent .circle{
		border-top:1px dotted blue;
		margin-bottom:10px;
	}

	.xperson-grid .person:nth-child(3n+0) .pcontent .circle{
		border-top:1px dotted red;
		margin-bottom:10px;
	}

	.xperson-grid .person:nth-child(5n+0) .pcontent .circle{
		border-top:1px dotted yellow;
		margin-bottom:10px;
	}

	.xperson-grid .person:nth-child(2n+0) .pcontent .circle{
		border-top:1px dotted green;
		margin-bottom:10px;
	}

	.xperson-grid .person:nth-child(4n+0) .pcontent .circle{
		border-top:1px dotted #666;
		margin-bottom:10px;
	}

	.btn-group{
		xborder:1px solid red;
	}

	.btn-group .btn, .btn-group .btn:hover, .btn-group .btn.active{
		border-radius:0;
		background:transparent;
		text-transform:uppercase;
		margin-right:3px;
		color:#333;
		border-top:0px solid #FFF;
		border-left:0px solid #FFF;
		border-right:0px solid #FFF;
		border-bottom:3px solid #333;
	}


	.btn-group .btn.btn-success{
		border-color:green;
		color:green;
	}

	.current-person{
		background:rgba(255, 255, 255, 0.95);
		margin-right:250px;
		margin-top:-50px;
		margin-bottom:50px;
		padding:50px 5% 100px;
		text-align:left;
		z-index:0;
	}

	.close-icon{
		float:right;
		cursor:pointer;
		margin-right:-25px;
		margin-top:-25px;
	}

	.person:hover{
		background:blue;
		color:#FFF;
	}

	.position{
		font-family:"Tahoma";
		font-size:60%;
		font-weight:normal;
	}

	.person-grid{
		display:grid;
		grid-template-columns: 1fr 1fr;
		grid-gap:25px;
		position:relative;
		z-index:-0;
	}

	.no-grid{
		font-size:70%;
	}

	.no-grid .person{
		padding:0;
		width:200px;
		min-height:auto;
		padding:15px 5px;
		text-transform: none;
		border-right:0px solid #FFF;
	}

	.page-image img{
		max-width:100%;
	}


	.page-image{
		background-size:cover;
		margin-bottom:25px;
	}

	.square{
		width:25%;
		overflow:hidden;
	}

	.square.blue{
		float:left;
		background:rgba(0,102,255,0.8);
	}

	.square.green{
		background:rgba(0,153,51,0.8);
		/*float:left;*/
	}

	.square.yellow{
		background:rgba(255,255,0,0.8);
		float:right;
	}

	.square.grey{
		background:rgba(204,204,204,0.5);
		/*clear:both;*/
		/*float:right;*/
	}

	.square:after {
	  content: "";
	  display: block;
	  padding-bottom: 100%;
	  /*background:transparent;*/
	}

	@media (max-width:768px){
		.person-grid{
			display:grid;
			grid-template-columns: 1fr;
		}

		.current-person{
			background:rgba(255, 255, 255, 0.95);
			margin-right:auto;
			xpadding:0;
			right:0;
			left:0;
			width:auto !important;
			margin-top:-50px;
			margin-bottom:50px;
			xpadding:50px 15px;
			text-align:left;
			z-index:0;
		}

		.close-icon{
			float:right;
			cursor:pointer;
			margin-right:5px;
			xmargin-top:15px;
		}

		.profile-pic{
			max-width:100%;
		}
	}
</style>
